import { FC, useEffect, useRef } from 'react'

import { useTranslation } from 'react-i18next'

import { PopupContent } from 'shared/ui/poup-content'

import s from './styles.module.scss'

interface Props {
  onConfirm: () => void
  onClose: () => void
}

export const AlmatySearchPopup: FC<Props> = ({ onConfirm, onClose }) => {
  const { t } = useTranslation()
  const dialogRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const previousFocus = document.activeElement
    dialogRef.current?.querySelector('button')?.focus()
    return () => {
      if (previousFocus instanceof HTMLElement && previousFocus.isConnected)
        previousFocus.focus()
    }
  }, [])

  return (
    <div
      ref={dialogRef}
      className={s.popup}
      onKeyDown={(event) => {
        if (event.key === 'Escape') onClose()
        if (event.key === 'Tab') {
          event.preventDefault()
          dialogRef.current?.querySelector('button')?.focus()
        }
      }}
      role="dialog"
      aria-modal="true"
      aria-label={t('tours_block.almaty_search_title')}
    >
      <PopupContent
        title={
          <span className="bold-20">
            {t('tours_block.almaty_search_title')}
          </span>
        }
        description={t('tours_block.almaty_search_description')}
        button={
          <span className="bold-17">
            {t('tours_block.almaty_search_button')}
          </span>
        }
        onClick={onConfirm}
      />
    </div>
  )
}
